import type {AdvancedSearchResponse} from '@api';
import type {StepConfig} from '../workflow';

export function resumableStepName(steps: StepConfig[], advancedSearch: AdvancedSearchResponse, workflowKeyForError?: string): string {
    for (const step of steps.slice().reverse()) {
        if (step.canResume(advancedSearch)) {
            return step.routeName;
        }
    }
    throw new Error(`No allowed step found in workflow ${workflowKeyForError ?? 'unknown'}`);
}

export function resolveAllowedStepName(steps: StepConfig[], wantedStepName: string, advancedSearch: AdvancedSearchResponse): string {
    const wantedStep = steps.find((step) => step.routeName === wantedStepName);

    if (wantedStep?.canEnter(advancedSearch)) {
        return wantedStepName;
    }

    return resumableStepName(steps, advancedSearch);
}
